<template>
  <div class="flex flex-col gap-4">
    <StartpageTeaserBanner />
    <div class="startpage-hero lg:min-h-[500px]">
      <StartpageHeroTemplateMobile :entries="pool" class="block sm:hidden" />
      <StartpageHeroTemplateTablet class="hidden sm:block lg:hidden" :entries="pool" />
      <StartpageHeroLoadingFrame
        :key="layout"
        :content-key="pool"
        class="hidden lg:block"
      >
        <template #placeholder>
          <StartpageHeroTemplateDummyTriplet v-if="layout === 'Compact'" />
          <StartpageHeroTemplateBanner v-else :entries="[]" />
        </template>
        <StartpageHeroTemplateTileTriplet v-if="layout === 'Compact'" :entries="pool" />
        <StartpageHeroTemplateTilePair v-else-if="layout === 'Balanced'" :entries="pool" />
        <StartpageHeroTemplateBanner v-else-if="layout === 'Simple'" :entries="pool" />
        <StartpageHeroTemplateBanner v-else :entries="pool" />
      </StartpageHeroLoadingFrame>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, inject } from 'vue';
import type { Ref } from 'vue';
import type { SliderEntry } from './SliderStructure';

interface StartpageConfig {
  layout?: string;
  sliders?: SliderEntry[];
}

const config = inject<Ref<StartpageConfig | null | undefined>>('startpageConfig');
const layout = computed(() => config?.value?.layout ?? 'default');
const pool = computed(() => config?.value?.sliders ?? []);
</script>
